import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBkrIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.10931 24.1964C9.40961 24.4967 9.40961 24.9795 9.10931 25.2798C8.80901 25.5801 8.32618 25.5801 8.02588 25.2798C7.72558 24.9795 7.72558 24.4967 8.02588 24.1964C8.32618 23.8961 8.80901 23.8961 9.10931 24.1964Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4636 25.5507C10.7639 25.851 10.7639 26.3338 10.4636 26.6341C10.1633 26.9344 9.68043 26.9344 9.38013 26.6341C9.07983 26.3338 9.07983 25.851 9.38013 25.5507C9.68043 25.2504 10.1691 25.2504 10.4636 25.5507Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4636 22.836C10.7639 23.1363 10.7639 23.6192 10.4636 23.9195C10.1633 24.2198 9.68043 24.2198 9.38013 23.9195C9.07983 23.6192 9.07983 23.1363 9.38013 22.836C9.68043 22.5416 10.1691 22.5416 10.4636 22.836Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8238 24.1964C12.1241 24.4967 12.1241 24.9795 11.8238 25.2798C11.5235 25.5801 11.0407 25.5801 10.7404 25.2798C10.4401 24.9795 10.4401 24.4967 10.7404 24.1964C11.0348 23.8961 11.5235 23.8961 11.8238 24.1964Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.4469 22.6065C5.4469 22.4829 5.547 22.3887 5.66476 22.3887C5.78841 22.3887 5.88263 22.4888 5.88263 22.6065C5.88263 22.7243 5.78253 22.8244 5.66476 22.8244C5.547 22.8244 5.4469 22.7302 5.4469 22.6065Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8356 16.2179C11.8356 16.0942 11.9357 16 12.0534 16C12.1771 16 12.2713 16.1001 12.2713 16.2179C12.2713 16.3356 12.1712 16.4357 12.0534 16.4357C11.9357 16.4357 11.8356 16.3415 11.8356 16.2179Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7699 17.2835C10.7699 17.1599 10.87 17.0657 10.9878 17.0657C11.1114 17.0657 11.2056 17.1658 11.2056 17.2835C11.2056 17.4013 11.1055 17.5014 10.9878 17.5014C10.87 17.5014 10.7699 17.4013 10.7699 17.2835Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.70398 18.3495C9.70398 18.2258 9.80408 18.1316 9.92184 18.1316C10.0455 18.1316 10.1397 18.2317 10.1397 18.3495C10.1397 18.4672 10.0396 18.5673 9.92184 18.5673C9.80408 18.5673 9.70398 18.4672 9.70398 18.3495Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.63831 19.4151C8.63831 19.2915 8.7384 19.1973 8.85617 19.1973C8.97982 19.1973 9.07403 19.2974 9.07403 19.4151C9.07403 19.5329 8.97393 19.633 8.85617 19.633C8.7384 19.633 8.63831 19.5329 8.63831 19.4151Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.57849 20.4749C7.57849 20.3513 7.67859 20.2571 7.79635 20.2571C7.92001 20.2571 8.01422 20.3572 8.01422 20.4749C8.01422 20.5927 7.91412 20.6928 7.79635 20.6928C7.6727 20.6987 7.57849 20.5986 7.57849 20.4749Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5127 21.5409C6.5127 21.4172 6.61279 21.323 6.73056 21.323C6.85421 21.323 6.94842 21.4231 6.94842 21.5409C6.94842 21.6586 6.84832 21.7587 6.73056 21.7587C6.60691 21.7587 6.5127 21.6645 6.5127 21.5409Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5127 23.6722C6.5127 23.5486 6.61279 23.4543 6.73056 23.4543C6.85421 23.4543 6.94842 23.5544 6.94842 23.6722C6.94842 23.79 6.84832 23.8901 6.73056 23.8901C6.60691 23.8901 6.5127 23.79 6.5127 23.6722Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9014 17.2835C12.9014 17.1599 13.0015 17.0657 13.1192 17.0657C13.2429 17.0657 13.3371 17.1658 13.3371 17.2835C13.3371 17.4013 13.237 17.5014 13.1192 17.5014C12.9956 17.5014 12.9014 17.4072 12.9014 17.2835Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8356 18.3495C11.8356 18.2258 11.9357 18.1316 12.0534 18.1316C12.1771 18.1316 12.2713 18.2317 12.2713 18.3495C12.2713 18.4672 12.1712 18.5673 12.0534 18.5673C11.9357 18.5673 11.8356 18.4672 11.8356 18.3495Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7699 19.4151C10.7699 19.2915 10.87 19.1973 10.9878 19.1973C11.1114 19.1973 11.2056 19.2974 11.2056 19.4151C11.2056 19.5329 11.1055 19.633 10.9878 19.633C10.87 19.633 10.7699 19.5329 10.7699 19.4151Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.70398 20.4749C9.70398 20.3513 9.80408 20.2571 9.92184 20.2571C10.0455 20.2571 10.1397 20.3572 10.1397 20.4749C10.1397 20.5927 10.0396 20.6928 9.92184 20.6928C9.80408 20.6987 9.70398 20.5986 9.70398 20.4749Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.63831 21.5409C8.63831 21.4172 8.7384 21.323 8.85617 21.323C8.97982 21.323 9.07403 21.4231 9.07403 21.5409C9.07403 21.6586 8.97393 21.7587 8.85617 21.7587C8.7384 21.7587 8.63831 21.6645 8.63831 21.5409Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.57849 22.6065C7.57849 22.4829 7.67859 22.3887 7.79635 22.3887C7.92001 22.3887 8.01422 22.4888 8.01422 22.6065C8.01422 22.7243 7.91412 22.8244 7.79635 22.8244C7.6727 22.8244 7.57849 22.7302 7.57849 22.6065Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9612 18.3495C13.9612 18.2258 14.0613 18.1316 14.179 18.1316C14.3027 18.1316 14.3969 18.2317 14.3969 18.3495C14.3969 18.4672 14.2968 18.5673 14.179 18.5673C14.0613 18.5673 13.9671 18.4672 13.9612 18.3495Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9014 19.4151C12.9014 19.2915 13.0015 19.1973 13.1192 19.1973C13.2429 19.1973 13.3371 19.2974 13.3371 19.4151C13.3371 19.5329 13.237 19.633 13.1192 19.633C12.9956 19.633 12.9014 19.5329 12.9014 19.4151Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8356 20.4749C11.8356 20.3513 11.9357 20.2571 12.0534 20.2571C12.1771 20.2571 12.2713 20.3572 12.2713 20.4749C12.2713 20.5927 12.1712 20.6928 12.0534 20.6928C11.9357 20.6987 11.8356 20.5986 11.8356 20.4749Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7699 21.5409C10.7699 21.4172 10.87 21.323 10.9878 21.323C11.1114 21.323 11.2056 21.4231 11.2056 21.5409C11.2056 21.6586 11.1055 21.7587 10.9878 21.7587C10.87 21.7587 10.7699 21.6645 10.7699 21.5409Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.027 19.4151C15.027 19.2915 15.1271 19.1973 15.2448 19.1973C15.3685 19.1973 15.4627 19.2974 15.4627 19.4151C15.4627 19.5329 15.3626 19.633 15.2448 19.633C15.1271 19.633 15.027 19.5329 15.027 19.4151Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9612 20.4749C13.9612 20.3513 14.0613 20.2571 14.179 20.2571C14.3027 20.2571 14.3969 20.3572 14.3969 20.4749C14.3969 20.5927 14.2968 20.6928 14.179 20.6928C14.0613 20.6987 13.9612 20.5986 13.9612 20.4749Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9014 21.5409C12.9014 21.4172 13.0015 21.323 13.1192 21.323C13.2429 21.323 13.3371 21.4231 13.3371 21.5409C13.3371 21.6586 13.237 21.7587 13.1192 21.7587C12.9956 21.7587 12.9014 21.6645 12.9014 21.5409Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8356 22.6065C11.8356 22.4829 11.9357 22.3887 12.0534 22.3887C12.1771 22.3887 12.2713 22.4888 12.2713 22.6065C12.2713 22.7243 12.1712 22.8244 12.0534 22.8244C11.9357 22.8244 11.8356 22.7302 11.8356 22.6065Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0928 20.4749C16.0928 20.3513 16.1929 20.2571 16.3106 20.2571C16.4343 20.2571 16.5285 20.3572 16.5285 20.4749C16.5285 20.5927 16.4284 20.6928 16.3106 20.6928C16.1929 20.6987 16.0928 20.5986 16.0928 20.4749Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.027 21.5409C15.027 21.4172 15.1271 21.323 15.2448 21.323C15.3685 21.323 15.4627 21.4231 15.4627 21.5409C15.4627 21.6586 15.3626 21.7587 15.2448 21.7587C15.1271 21.7587 15.027 21.6645 15.027 21.5409Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9612 22.6065C13.9612 22.4829 14.0613 22.3887 14.179 22.3887C14.3027 22.3887 14.3969 22.4888 14.3969 22.6065C14.3969 22.7243 14.2968 22.8244 14.179 22.8244C14.0613 22.8244 13.9612 22.7302 13.9612 22.6065Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9014 23.6722C12.9014 23.5486 13.0015 23.4543 13.1192 23.4543C13.2429 23.4543 13.3371 23.5544 13.3371 23.6722C13.3371 23.79 13.237 23.8901 13.1192 23.8901C12.9956 23.8901 12.9014 23.79 12.9014 23.6722Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7699 27.9295C10.7699 27.8059 10.87 27.7117 10.9878 27.7117C11.1114 27.7117 11.2056 27.8118 11.2056 27.9295C11.2056 28.0473 11.1055 28.1474 10.9878 28.1474C10.87 28.1474 10.7699 28.0532 10.7699 27.9295Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0928 22.6065C16.0928 22.4829 16.1929 22.3887 16.3106 22.3887C16.4343 22.3887 16.5285 22.4888 16.5285 22.6065C16.5285 22.7243 16.4284 22.8244 16.3106 22.8244C16.1929 22.8244 16.0928 22.7302 16.0928 22.6065Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.027 23.6722C15.027 23.5486 15.1271 23.4543 15.2448 23.4543C15.3685 23.4543 15.4627 23.5544 15.4627 23.6722C15.4627 23.79 15.3626 23.8901 15.2448 23.8901C15.1271 23.8901 15.027 23.79 15.027 23.6722Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9612 24.7381C13.9612 24.6145 14.0613 24.5203 14.179 24.5203C14.3027 24.5203 14.3969 24.6204 14.3969 24.7381C14.3969 24.8559 14.2968 24.956 14.179 24.956C14.0613 24.956 13.9612 24.8559 13.9612 24.7381Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9014 25.7979C12.9014 25.6743 13.0015 25.5801 13.1192 25.5801C13.2429 25.5801 13.3371 25.6802 13.3371 25.7979C13.3371 25.9157 13.237 26.0158 13.1192 26.0158C12.9956 26.0217 12.9014 25.9216 12.9014 25.7979Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8356 26.8639C11.8356 26.7402 11.9357 26.646 12.0534 26.646C12.1771 26.646 12.2713 26.7461 12.2713 26.8639C12.2713 26.9816 12.1712 27.0817 12.0534 27.0817C11.9357 27.0817 11.8356 26.9875 11.8356 26.8639Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8356 28.9952C11.8356 28.8716 11.9357 28.7773 12.0534 28.7773C12.1771 28.7773 12.2713 28.8774 12.2713 28.9952C12.2713 29.1189 12.1712 29.2131 12.0534 29.2131C11.9357 29.2131 11.8356 29.113 11.8356 28.9952Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.2242 22.6065C18.2242 22.4829 18.3243 22.3887 18.4421 22.3887C18.5658 22.3887 18.66 22.4888 18.66 22.6065C18.66 22.7243 18.5599 22.8244 18.4421 22.8244C18.3185 22.8244 18.2242 22.7302 18.2242 22.6065Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0928 24.7381C16.0928 24.6145 16.1929 24.5203 16.3106 24.5203C16.4343 24.5203 16.5285 24.6204 16.5285 24.7381C16.5285 24.8559 16.4284 24.956 16.3106 24.956C16.1929 24.956 16.0928 24.8559 16.0928 24.7381Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.027 25.7979C15.027 25.6743 15.1271 25.5801 15.2448 25.5801C15.3685 25.5801 15.4627 25.6802 15.4627 25.7979C15.4627 25.9157 15.3626 26.0158 15.2448 26.0158C15.1271 26.0217 15.027 25.9216 15.027 25.7979Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.9612 26.8639C13.9612 26.7402 14.0613 26.646 14.179 26.646C14.3027 26.646 14.3969 26.7461 14.3969 26.8639C14.3969 26.9875 14.2968 27.0817 14.179 27.0817C14.0613 27.0817 13.9612 26.9875 13.9612 26.8639Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9014 27.9295C12.9014 27.8059 13.0015 27.7117 13.1192 27.7117C13.2429 27.7117 13.3371 27.8118 13.3371 27.9295C13.3371 28.0473 13.237 28.1474 13.1192 28.1474C12.9956 28.1474 12.9014 28.0532 12.9014 27.9295Z",
			fill: "#5FBFED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.7729 20.1807H24.8131C24.6777 20.1807 24.5658 20.2925 24.5658 20.428V28.8952C24.5658 29.0306 24.6777 29.1425 24.8131 29.1425H25.7729C25.9083 29.1425 26.0202 29.0306 26.0202 28.8952V20.428C26.0202 20.2925 25.9083 20.1807 25.7729 20.1807Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.5445 22.8775C38.5445 23.3838 38.2442 23.8137 37.8084 24.008L38.8624 25.062C39.5455 24.5733 39.9871 23.7784 39.9871 22.8716C39.9871 21.3819 38.78 20.1748 37.2903 20.1748H33.5454C33.41 20.1748 33.2981 20.2867 33.2981 20.4221V28.8952C33.2981 29.0306 33.41 29.1425 33.5454 29.1425H34.5052C34.6406 29.1425 34.7525 29.0306 34.7525 28.8952V21.6292H37.3021C37.991 21.6292 38.5445 22.1885 38.5445 22.8775Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0918 22.4535C21.0918 22.7126 20.9682 22.9481 20.7798 23.0953C21.3274 23.0953 21.8455 23.2307 22.3048 23.4663C22.4579 23.1601 22.5462 22.8186 22.5462 22.4535C22.5462 21.1993 21.5276 20.1807 20.2734 20.1807H16.3165C16.1811 20.1807 16.0692 20.2925 16.0692 20.428V28.8952C16.0692 29.0306 16.1811 29.1425 16.3165 29.1425H17.2763C17.4117 29.1425 17.5236 29.0306 17.5236 28.8952V21.635H20.2734C20.7209 21.635 21.0918 22.0001 21.0918 22.4535Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.7797 23.7546H18.4244C18.289 23.7546 18.1771 23.8665 18.1771 24.0019V25.2031H20.7797C21.4686 25.2031 22.0221 25.7625 22.0221 26.4455C22.0221 27.1345 21.4627 27.6879 20.7797 27.6879H18.4244C18.289 27.6879 18.1771 27.7998 18.1771 27.9353V28.895C18.1771 29.0305 18.289 29.1423 18.4244 29.1423H20.7797C22.2694 29.1423 23.4765 27.9353 23.4765 26.4455C23.4765 24.9558 22.2694 23.7546 20.7797 23.7546Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M41.6003 28.7185L37.0664 24.1905C37.0193 24.1434 36.9605 24.1199 36.8898 24.1199H35.5355C35.4001 24.1199 35.2882 24.2317 35.2882 24.3672C35.2882 24.4378 35.3176 24.4967 35.3589 24.5438L39.8869 29.0718C39.934 29.1189 39.9929 29.1425 40.0635 29.1425H41.4178C41.5532 29.1425 41.6651 29.0306 41.6651 28.8952C41.671 28.8304 41.6416 28.7657 41.6003 28.7185Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.6071 29.0718C30.6542 29.1189 30.713 29.1424 30.7837 29.1424H32.138C32.2734 29.1424 32.3853 29.0305 32.3853 28.8951C32.3853 28.8245 32.3559 28.7656 32.3146 28.7185L27.4098 23.8077C27.3156 23.7135 27.1566 23.7135 27.0624 23.8077L26.3852 24.4849C26.291 24.5791 26.291 24.7381 26.3852 24.8323L30.6071 29.0718Z",
			fill: "#003460"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.6071 20.2572C30.6542 20.2101 30.7131 20.1865 30.7837 20.1865H32.138C32.2735 20.1865 32.3853 20.2984 32.3853 20.4338C32.3853 20.5045 32.3559 20.5634 32.3147 20.6105L28.8995 24.0315C28.8053 24.1257 28.6463 24.1257 28.5521 24.0315L27.875 23.3544C27.7808 23.2602 27.7808 23.1012 27.875 23.007L30.6071 20.2572Z",
			fill: "#5FBFED"
		})
	]
});
export default SvgBkrIcon;
